// Función de validación mejorada que incluye archivos
export const validateForm = (formData, validationRules, files = {}) => {
  let isValid = true;
  const errors = {};

  // Normalizar los campos del formulario
  const normalizedFormData = {};
  for (const field in formData) {
    if (formData.hasOwnProperty(field)) {
      const value = formData[field];
      normalizedFormData[field] =
        typeof value === 'string' ? value.normalize('NFC') : value;
    }
  }

  // Agregar archivos a los datos normalizados para validación
  const allData = { ...normalizedFormData, ...files };

  for (const fieldName in validationRules) {
    if (validationRules.hasOwnProperty(fieldName)) {
      const rules = validationRules[fieldName];
      
      // Determinar si es un campo de archivo o un campo normal
      const isFileField = files.hasOwnProperty(fieldName);
      const value = isFileField ? files[fieldName] : String(formData[fieldName] || '').trim();
      
      const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i;
      // Patrón de inyección más ligero - solo detecta los casos más peligrosos
      const injectionPattern = /(<script[^>]*>|<\/script>|javascript:|on\w+\s*=|<iframe|<object|<embed|eval\s*\(|setTimeout\s*\(|setInterval\s*\(|Function\s*\(|alert\s*\(|confirm\s*\(|prompt\s*\()/i;


      for (const rule of rules) {
        // Validación de campo requerido
        if (rule.required) {
          if (isFileField) {
            if (!value || (Array.isArray(value) && value.length === 0)) {
              errors[fieldName] = rule.message;
              isValid = false;
              break;
            }
          } else {
            if (!value) {
              errors[fieldName] = rule.message;
              isValid = false;
              break;
            }
          }
        }
        // Validaciones específicas para archivos
        if (isFileField && value) {
          const fileArray = Array.isArray(value) ? value : [value];
          
          // Validar extensiones de archivo
          if (rule.allowedExtensions) {
            // Permitir allowedExtensions dinámicas basadas en formData
            const allowedExts = typeof rule.allowedExtensions === 'function' 
              ? rule.allowedExtensions(allData) 
              : rule.allowedExtensions;
            
            const invalidFile = fileArray.find(file => {
              const extension = file.name.split('.').pop().toLowerCase();
              return !allowedExts.includes(extension);
            });
            
            if (invalidFile) {
              errors[fieldName] = rule.message || `Extensión no permitida: ${invalidFile.name}`;
              isValid = false;
              break;
            }
          }
/*
          // Validar tamaño máximo de archivo
          if (rule.maxSize) {
            const invalidFile = fileArray.find(file => file.size > rule.maxSize);
            
            if (invalidFile) {
              errors[fieldName] = rule.message || `Archivo demasiado grande: ${invalidFile.name}`;
              isValid = false;
              break;
            }
          }

          // Validar tamaño mínimo de archivo
          if (rule.minSize) {
            const invalidFile = fileArray.find(file => file.size < rule.minSize);
            
            if (invalidFile) {
              errors[fieldName] = rule.message || `Archivo demasiado pequeño: ${invalidFile.name}`;
              isValid = false;
              break;
            }
          }

          // Validar número máximo de archivos
          if (rule.maxFiles && fileArray.length > rule.maxFiles) {
            errors[fieldName] = rule.message || `Máximo ${rule.maxFiles} archivos permitidos`;
            isValid = false;
            break;
          }

          // Validar número mínimo de archivos
          if (rule.minFiles && fileArray.length < rule.minFiles) {
            errors[fieldName] = rule.message || `Mínimo ${rule.minFiles} archivos requeridos`;
            isValid = false;
            break;
          }
*/
          // Validar tipo MIME
          if (rule.allowedMimeTypes) {
            // Permitir allowedMimeTypes dinámicos basados en formData
            const allowedMimes = typeof rule.allowedMimeTypes === 'function'
              ? rule.allowedMimeTypes(allData)
              : rule.allowedMimeTypes;
            
            const invalidFile = fileArray.find(file => 
              !allowedMimes.includes(file.type)
            );
            
            if (invalidFile) {
              errors[fieldName] = rule.message || `Tipo de archivo no permitido: ${invalidFile.name}`;
              isValid = false;
              break;
            }
          }
        }

        // Validaciones para campos de texto (mantener las existentes)
        if (!isFileField) {
          // Validación de inyección de código - solo para campos de texto
          if (injectionPattern.test(value)) {
            errors[fieldName] = rule.injectionMessage || 'El campo contiene caracteres potencialmente peligrosos';
            isValid = false;
            break;
          }

          if (rule.pattern && !rule.pattern.test(value)) {
            errors[fieldName] = rule.message;
            isValid = false;
            break;
          }

          if (!urlPattern.test(value) && rule.isURL) {
            errors[fieldName] = 'Ingrese una URL válida';
            isValid = false;
            break;
          }
          
          if (urlPattern.test(value) && rule.isURL === undefined) {
            errors[fieldName] = 'El campo no debe contener una URL';
            isValid = false;
            break;
          }
        }

        // Validador personalizado (funciona para ambos tipos)
        if (rule.customValidator && !rule.customValidator(value, allData)) {
          errors[fieldName] = rule.message;
          isValid = false;
          break;
        }
      }
    }
  }

  return { isValid, errors };
};